import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'types/RootStateType'

// https://github.com/reduxjs/react-redux/releases/tag/v9.1.0
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export type AppThunkAction<ReturnType> = ThunkAction<ReturnType, RootState, unknown, UnknownAction>
